module.exports = __webpack_public_path__ + "media/assets/icons/ic_outline-family-restroom-564fabeb65129feb778e06b2d58d322c.svg";